import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class ComunaService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerComunaSegunCodigo(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: comunaInputType) {
          comuna {
            obtenerComunaSegunCodigo(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  provincia_codigo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.comuna.obtenerComunaSegunCodigo;
            callback({ mensajes, respuesta });
        });
    }
    obtenerDatosComunas(callback) {
        this.gqlclient.query({
            query: gql `
        query {
          comuna {
            obtenerSegunFiltro(
              filtro: {
                exacto: {
                  codigo: -1
                  provincia_codigo: -1
                  nombre: ""
                  codigo_region: -1
                }
              }
            ) {
              respuesta {
                registros {
                  codigo
                  nombre
                  provincia_codigo
                }
              }
            }
          }
        }
        `,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.comuna.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerComunayVendedorConfirmacionNventa(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($rutEmpresa: Decimal, $sucursalEmpresa: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int, $soloAprobadosAnalisis: Boolean) {
          comuna {
            obtenerComunaSegunConfirmacionNotaVenta(rutEmpresa: $rutEmpresa, sucursalEmpresa: $sucursalEmpresa, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina, soloAprobadosAnalisis: $soloAprobadosAnalisis) {
              mensajes {
                codigo
                contexto
                texto
                tipo
                __typename
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  nombre
                  codigo_vendedor
                  vendedor_nombre
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.comuna.obtenerComunaSegunConfirmacionNotaVenta;
            callback({ mensajes, respuesta });
        });
    }
}
ComunaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ComunaService_Factory() { return new ComunaService(i0.ɵɵinject(i1.GraphQLClient)); }, token: ComunaService, providedIn: "root" });
